export default function OrdersToolbar({
  search,
  onSearchChange,
  dateFilter,
  onDateFilterChange,
  customFrom,
  customTo,
  onCustomFromChange,
  onCustomToChange,
  sortBy,
  onSortChange,
}) {
  return (
    <div className="glass-card mb-6 space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3">
        <input
          type="search"
          placeholder="Search ID, name, phone, email..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="input"
        />
        <select value={dateFilter} onChange={(e) => onDateFilterChange(e.target.value)} className="input">
          <option value="">All Dates</option>
          <option value="today">Today</option>
          <option value="yesterday">Yesterday</option>
          <option value="last7">Last 7 Days</option>
          <option value="last30">Last 30 Days</option>
          <option value="thisMonth">This Month</option>
          <option value="lastMonth">Last Month</option>
          <option value="custom">Custom Range</option>
        </select>
        <select value={sortBy} onChange={(e) => onSortChange(e.target.value)} className="input">
          <option value="newest">Newest First</option>
          <option value="oldest">Oldest First</option>
          <option value="highest">Highest Order Value</option>
          <option value="lowest">Lowest Order Value</option>
        </select>
      </div>
      {dateFilter === 'custom' && (
        <div className="grid grid-cols-2 gap-3 max-w-md">
          <input type="date" value={customFrom} onChange={(e) => onCustomFromChange(e.target.value)} className="input" />
          <input type="date" value={customTo} onChange={(e) => onCustomToChange(e.target.value)} className="input" />
        </div>
      )}
    </div>
  );
}
